import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.tsx';
import { auth as apiAuth } from '../services/api.ts';

type ProtectedRouteProps = Omit<RouteProps, 'component'> & {
  component: React.ComponentType<any>;
  path?: string;
  exact?: boolean;
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component: Component, ...rest }) => {
  const { session, loading } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (loading) return null;

        return (!!session || apiAuth.isAuthenticated()) ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        );
      }}
    />
  );
};

export default ProtectedRoute;